import { request } from '@umijs/max';

const AUTH_BASE_URL = process.env.Auth_URL || '';

export interface GeoLocation {
  country?: string;
  countryCode?: string;
  region?: string;
  city?: string;
  latitude?: number;
  longitude?: number;
}

export interface ClientInfo {
  screen?: string;
  viewport?: string;
  timezone?: string;
  tz_offset?: number;
  language?: string;
  languages?: string;
  platform?: string;
  cores?: number;
  dpr?: number;
  touch?: number;
  gpu?: string;
  webdriver?: boolean;
  cookie?: boolean;
}

export interface AccessLog {
  user_id?: string;
  display_name?: string;
  email?: string;
  ip: string;
  geo?: GeoLocation;
  fingerprint?: string;
  client?: ClientInfo;
  method: string;
  path: string;
  operation_type: string;
  status_code: number;
  latency_ms?: number;
  user_agent?: string;
  device?: string;
  os?: string;
  browser?: string;
  referer?: string;
  request_id?: string;
  source: string;
  is_action: boolean;
  created_at: string;
}

export interface AccessLogListResponse {
  list: AccessLog[];
  total: number;
  page: number;
  pages: number;
}

export interface AccessUniqueUser {
  user_id: string;
  is_guest: boolean;
  display_name?: string;
  email?: string;
  ip: string;
  geo?: GeoLocation;
  device?: string;
  os?: string;
  browser?: string;
  fingerprint?: string;
  client?: ClientInfo;
  visits: number;
  actions: number;
  user_count: number;
  ip_count: number;
  fp_count: number;
  first_seen: string;
  last_seen: string;
}

export interface AccessUniqueUserResponse {
  list: AccessUniqueUser[];
  total: number;
  page: number;
  pages: number;
}

export interface CountItem {
  key: string;
  count: number;
}

export interface AccessDailyPoint {
  date: string;
  views: number;
  uv: number;
  guests: number;
  actions: number;
}

export interface AccessAnalytics {
  start_date: string;
  end_date: string;
  total_views: number;
  total_uv: number;
  total_guests: number;
  total_guest_uv: number;
  total_actions: number;
  daily: AccessDailyPoint[];
  operations: CountItem[];
  countries: CountItem[];
  countries_by_code: CountItem[];
  regions: CountItem[];
  top_paths: CountItem[];
  devices: CountItem[];
}

export interface Resp<T> {
  success: boolean;
  data?: T;
  message?: string;
}

export interface AccessLogQuery {
  page?: number;
  page_size?: number;
  user_id?: string;
  keyword?: string;
  operation_type?: string;
  method?: string;
  path?: string;
  ip?: string;
  country?: string;
  device?: string;
  fingerprint?: string;
  only_action?: boolean;
  suspicious?: boolean;
  group_by?: string;
  start_time?: string;
  end_time?: string;
}

export async function getAccessLogs(
  params?: AccessLogQuery,
): Promise<Resp<AccessLogListResponse>> {
  return request(`${AUTH_BASE_URL}/api/admin/access-logs`, {
    method: 'GET',
    params,
  });
}

export async function getAccessUniqueUsers(
  params?: AccessLogQuery,
): Promise<Resp<AccessUniqueUserResponse>> {
  return request(`${AUTH_BASE_URL}/api/admin/access-logs/unique-users`, {
    method: 'GET',
    params,
  });
}

export async function getAccessAnalytics(params?: {
  start_date?: string;
  end_date?: string;
  start_time?: string;
  end_time?: string;
}): Promise<Resp<AccessAnalytics>> {
  return request(`${AUTH_BASE_URL}/api/admin/access-logs/analytics`, {
    method: 'GET',
    params,
  });
}
